import {BookingTypeEnum} from '../../constants';
import {examConfig, healthConfig, odontoConfig, telehealthConfig} from './serviceConfig';
import {HandleServiceTypeConfigs} from './types';

const handleServiceTypeConfigs = ({
	currentSearchParams,
	setBookingData,
	selectedServiceType,
	phone,
	email,
}: HandleServiceTypeConfigs) => {
	const props = {currentSearchParams, setBookingData, phone, email};

	switch (selectedServiceType) {
		case BookingTypeEnum.TELEHEALTH:
			return telehealthConfig(props);
		case BookingTypeEnum.HEALTH:
			return healthConfig(props);
		case BookingTypeEnum.ODONTO:
			return odontoConfig(props);
		case BookingTypeEnum.EXAM:
			return examConfig(props);
		default:
			return '';
	}
};

export {odontoConfig, handleServiceTypeConfigs};
